import type Locale from 'date-fns/locale';
import * as Locales from 'date-fns/locale';

export const getDateFnsLocale = (code: string): Locale => {
  const [lang, country] = code.split('-');
  let contryCode = '';
  if (country) {
    contryCode = country.charAt(0).toUpperCase() + country.slice(1);
  }
  return Locales[lang + contryCode] ? Locales[lang + contryCode] : Locales[lang];
};
